import { Component, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: "var(--s-8)",
            maxWidth: 480,
            margin: "10vh auto",
            background: "var(--ink-1)",
            border: "1px solid rgba(239,68,68,0.30)",
            borderRadius: "var(--r-lg)",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "var(--danger)", marginBottom: "var(--s-3)" }}>
            Algo quebrou
          </h1>
          <p
            style={{
              color: "var(--cream-2)",
              fontSize: 14,
              marginBottom: "var(--s-5)",
            }}
          >
            {this.state.error.message}
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Recarregar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
